<template>
    <DCard padding>
        <Form
            :errors="errors"
            :configurations="configurations"
            :brands="brands"
            :placeholders="placeholders"
            :all-languages="allLanguages"
            @InvoicePdfSettingFormSubmit="save"
        />
    </DCard>
</template>

<script>

import Form from '~@/Components/Settings/InvoicePdfSettings/Form.vue'

export default {
    name: 'EditInvoicePdfSettingsConfigurations',
    components: { Form },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        configurations: {
            type: Array,
            default: () => { return [] }
        },
        placeholders: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        allLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            form: null,
            invoicePdfSettingsData: [],
            edit: true
        }
    },
    methods: {
        save (form) {
            form.post(this.$route('settings.invoice-pdf-settings.update'))
        }
    }
}
</script>
